let descriptionLimit = 1024
export default {
  validate(object, errors) {
    if (!object.title) errors['title'] = true
    if (!object.description) errors['description'] = true
    if (object.description.length > descriptionLimit) errors['description'] = true
    if (!object.grades.length > 0) errors['grades'] = true
    if (!object.subjects.length > 0) errors['subjects'] = true
    if (!object.terms) errors['terms'] = true
    if (!object.country) errors['country'] = true
    if (!object.language) errors['language'] = true
    if (object.standard.length > 0) {
      if (!object.strands.length > 0) errors['strands'] = true
    }
    return Object.values(errors)
  }
}
